import { Component } from '@angular/core';

@Component({
  selector: 'app-organizer-client',
  imports: [],
  templateUrl: './organizer-client.html',
  styleUrl: './organizer-client.css',
})
export class OrganizerClient {
  clients = Array(5);
}
